import React, {useState} from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import Tabs, { Tab } from '../../Components/Containers/Tabs/Tabs';
import Payments from './Payments/Payments';
import Transactions from './Transactions/Transactions';
import { usePreference } from '../../Data/Preference';
import NoItems from '../../Components/EmptyStates/NoItems';
import { useNavigate } from 'react-router-dom';
import { useSession } from '../../Components/Session';
import { useDialogues } from '../../Components/Dialogues';
import Export from './Export';

const Main = ({account}) => {
    const [tab, setTab] = usePreference('paymentsTab', 'Payments');
    const [exporting, setExporting] = useState(false);

    return <>
        <TopBar title="Payments"
            dropdownOptions={[
                {
                    title: 'Export payments',
                    icon: 'CloudArrowDown',
                    onClick: () => setExporting(true)
                }
            ]}
        />
        <Page className="page-padding" zeroPad>
            <Tabs selected={tab} onChange={setTab}>
                <Tab title="Payments">
                    <Payments />
                </Tab>
                <Tab title="Transactions">
                    {account.connectedBanks?.length ? <Transactions /> : <NoConnectedBanks />}
                </Tab>
            </Tabs>
        </Page>
        {exporting && <Export isOpen={exporting} setIsOpen={setExporting} />}
    </>
}

const NoConnectedBanks = () => {
    const navigate = useNavigate();
    const {hasFeature} = useSession();
    const {featureUnavailable} = useDialogues();

    return <NoItems
        icon="BuildingColumns"
        title="No connected banks"
        message={<>
            Connect your bank account to automatically be match bank transfers to your customers balances.
        </>}
        onClick={() => hasFeature('BANK_RECONCILIATION') ? navigate('/settings/payments/bank-reconciliation') : featureUnavailable('BANK_RECONCILIATION')}
    />
}

export default Main;
